import { render, staticRenderFns } from "./GroupProfilePhoto.vue?vue&type=template&id=5bede4e1&"
import script from "./GroupProfilePhoto.vue?vue&type=script&lang=ts&"
export * from "./GroupProfilePhoto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports